module.exports = __webpack_public_path__ + "static/video_sp_en-33f367c095cf8d64bcd4b3faf0b73483.mp4";